__turbopack_context__.v({
  "container": "CartItem-module-scss-module__zmLCfW__container",
  "discountPrice": "CartItem-module-scss-module__zmLCfW__discountPrice",
  "highlight": "CartItem-module-scss-module__zmLCfW__highlight",
  "highlightingContainer": "CartItem-module-scss-module__zmLCfW__highlightingContainer",
  "itemCost": "CartItem-module-scss-module__zmLCfW__itemCost",
  "itemDetailsContainer": "CartItem-module-scss-module__zmLCfW__itemDetailsContainer",
  "itemQuantity": "CartItem-module-scss-module__zmLCfW__itemQuantity",
  "noModifications": "CartItem-module-scss-module__zmLCfW__noModifications",
  "productNameContainer": "CartItem-module-scss-module__zmLCfW__productNameContainer",
  "quantityButton": "CartItem-module-scss-module__zmLCfW__quantityButton",
  "quantityText": "CartItem-module-scss-module__zmLCfW__quantityText",
  "selectedItemContainer": "CartItem-module-scss-module__zmLCfW__selectedItemContainer",
  "separator": "CartItem-module-scss-module__zmLCfW__separator",
});
